// Formulario para dar de alta a un nuevo usuario ( cliente role = 4)

import React from 'react'

import { ApiCallPost } from '../ApiCall/ApiCall'

import { useLocation  , useNavigate } from "react-router-dom";

function SignUp() {


    const location = useLocation();

    const navigate = useNavigate();

    if ( location.state !== null || location.state === undefined )
    {
        console.log( "location.state = ", location.state )
    }
    else
    {
        console.log( "location.state = null" )
        alert("No estas autorizado para entrar a esta pagina")

        navigate("/login")

        return ;

    }

    function onSubmit(e) {
        e.preventDefault()
        const persona = {
            "user": document.getElementById("correo").value,
            "password": document.getElementById("password").value,
            "nombre": document.getElementById("nombre").value,
            "telefono": document.getElementById("telefono").value,
            "role": 4 ,
            "dTimeStamp": new Date()
        }
        console.log("persona = " , persona)

        //return ;

        ApiCallPost( 'adduser' , persona)
        .then( response => {

            if ( response === 0 )
            {
                alert( "El usuario " + persona.nombre  + " ya existe")
                return ;
            }
            else{ // Aqui response llega > 0
                alert( "El usuario se dio de alta correctamente")
                return ;

            }

        })
        .catch( err => {

            alert( "Error al dar de alta al usuario")

        })

        // ApiCallPost('adduser', 

        //      persona)
        
        //     .then(res => res.json())
        //     .then(data => console.log(data))
        //     .catch(err => console.log(err))
    }

// marginLeft:'200px', marginRight:'200px'
  return (
    <div className='container-flow mt-5' style={{marginLeft:'20%' , marginRight :'20%'}}>

        <div  >
            <h1>Alta de usuarios</h1>
        </div>


        
        <div>
    
        <form onSubmit={onSubmit}>
            <div className="row mt-5">
                <div className="col-4">

                <label className="form-label m-0" htmlFor="correo">Correo</label>
                    <input type="email" className="form-control" id="correo"  
                    style={{marginTop:6,height:'40px'}}/>

                </div>
            </div>
            
            
            <div className='row'>
                <div className="col-4">

                    <label className="form-label m-0" htmlFor="password">Password</label>
                        <input style={{height:'40px'}} type="password" 
                        className="form-control pt-3 mt-2" id="password" />


                </div>
            
            </div>

            <div className='row'>
                <div className='col-12'>

                    <label className="form-label m-0" htmlFor="descripcion">Nombre</label>
                        <input type="text" className="form-control" id="nombre"
                        style={{marginTop:6,height:'40px'}} />

                </div>
            </div>

            <div className='row'>
                <div className='col-4'>

                    <label className="form-label m-0" htmlFor="telefono">Teléfono</label>
                        <input type="text" className="form-control" id="telefono"
                        style={{marginTop:6,height:'40px'}} />

                </div>
            </div>
            

            <div className='row mt-5'>
                <div className='col-6'>
                    <button type='submit' className="btn btn-primary mt-3 button-3">Agregar Usuario</button>
                </div>
            </div>
            
        </form>

        </div>
    
  </div>

  )
}

export default SignUp